/* eslint-disable react/jsx-pascal-case */
import { message, Button, Col, ConfigProvider, Form, Tag, Row, Select, Space, Table, Modal, Popconfirm, InputNumber, Switch } from "./../../ui/ot";
import dayjs from 'dayjs';
import React, { useContext, useEffect, useRef, lazy, Suspense, useState } from "react";
import { ProTableOt as ProTableOT } from "./../../ui/ot";
import { useClassifyStructureTypeCarousel } from "../controller/ClassifyStructureTypeCarouselController";
import ClassifyStructureTypeCarouselForm from "./ClassifyStructureTypeCarouselForm";
import axios from 'axios';
import { useParams } from "react-router-dom";
import Carousel_news_ticker from "../../cram_school/components/Carousel_news_ticker";
import { useCarousels } from "../controller/CarouselsController";
const setParamsFilter = (obj) => {
    //拿掉值為空或是null 的東西
    return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
}
const ClassifyStructureTypeCarousel = ({
    defaultSize = 20,
}) => {
    const {
        name
    } = useParams()
    axios.interceptors.request.use(
        async (config) => {
            const access_token = localStorage.getItem("access_token");

            if (access_token) {
                config.headers = {
                    ...config.headers,
                    authorization: `Bearer ${access_token}`,
                };
            }
            return config;
        },
        (error) => Promise.reject(error)
    );
    axios.interceptors.response.use(
        response => {
            return response
        },
        function (error) {
            const access_token_url = '/access_token';
            const config = error.config
            if (
                error.response?.status === 401 &&
                config.url === access_token_url
            ) {
                window.location.href = ('/login')
                return Promise.reject(error)
            }

            if (error.response?.status === 401 && !config._retry) {
                config._retry = true
                const refreshToken = localStorage.getItem('refresh_token')
                if (!refreshToken) window.location.href = ('/login')
                return axios
                    .post(access_token_url, {
                        refresh_token: refreshToken
                    })
                    .then(res => {
                        if (res?.status === 201) {
                            localStorage.setItem('access_token', res.data.access_token);
                            config.headers = {
                                ...config.headers,
                                authorization: `Bearer ${localStorage.getItem('access_token')}`,
                            };
                            return axios(config)
                        }
                    })
            }
            return Promise.reject(error)
        }
    )

    const columns = [
        {
            title: '預覽',
            dataIndex: 'classify_structure_type_file_data',
            key: 'classify_structure_type_file_data',
            sorter: false,
            disabled: true,
            render: (text) => {
                const data = text.find(_ => true);
                return <>
                    <PreviewCarousel
                        fileId={[data?.file_id]}
                    />
                </>
            }
        },
        {
            title: '連結',
            key: "path",
            dataIndex: 'path',
        },
        {
            title: '優先順序',
            dataIndex: 'index',
            key: 'index',
        },
        {
            title: '開始時間',
            dataIndex: 'start_time',
            key: 'start_time',
        },
        {
            title: '結束時間',
            dataIndex: 'end_time',
            key: 'end_time',
        },
    ];
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(defaultSize ? defaultSize : 20)
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([])
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]
            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.classify_structure_type_carousel_id)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.classify_structure_type_carousel_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]
            if (selected) {
                select_temp.push(record.classify_structure_type_carousel_id)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.classify_structure_type_carousel_id)
                selectRow = selectRow.filter(row => row.classify_structure_type_carousel_id !== record.classify_structure_type_carousel_id)
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)
        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };
    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)

    const [form] = Form.useForm();

    const [axiosMode, setAxiosMode] = useState("get")
    const [showType, setShowType] = useState("News") // 顯示News OR NewsType
    const onCleanSelected = () => {
        setSelectedRowKeys([])
        setSelectedRowsInfo([])
    }
    const handleAddRow = () => {
        setAxiosMode("post")
        setModalOpen(true)
        form.resetFields()
    }
    const handleEditRow = (record) => {
        setAxiosMode("patch")
        setModalOpen(true)
        let start_time = record?.start_time && dayjs(record?.start_time, "YYYY-MM-DD HH:mm:ss")
        let end_time = record?.end_time && dayjs(record?.end_time, "YYYY-MM-DD HH:mm:ss")


        form.resetFields()
        form.setFieldsValue({
            ...record,
            start_time,
            end_time,
        })
    }
    const handleDeleteRow = (id) => {
        let data = []
        if (id) {
            data = [{
                classify_structure_type_carousel_id: id
            }]
        }

        else {
            data = selectedRowsInfo.map((val) => {
                return {
                    classify_structure_type_carousel_id: val?.classify_structure_type_carousel_id
                }
            })
        }
        if (data.length > 0) {
            deleteClassifyStructureTypeCarouselData(data)
        }
        else {
            message.info("請選擇項目")
        }
    }

    const onFormFinish = (values) => {
        if (axiosMode === "post") {
            postClassifyStructureTypeCarouselData([
                {
                    ...values,
                    carousel_id: CarouselsData.find(_ => true)?.carousel_id
                }
            ])
        }
        else if (axiosMode === "patch") {
            patchClassifyStructureTypeCarouselData([values])
        }
    }
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])

            }
            setModalLoading(false)
            setModalOpen(false)
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                actionRef.current.reloadAndRest();
            }
            setModalLoading(false)
            setModalOpen(false)
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    }

    const {
        CarouselsData,
        getCarouselsData,
    } = useCarousels({
        onFinish,
        onBefore,
    })

    const {
        getClassifyStructureTypeCarouselData,
        postClassifyStructureTypeCarouselData,
        patchClassifyStructureTypeCarouselData,
        deleteClassifyStructureTypeCarouselData,
    } = useClassifyStructureTypeCarousel({
        onFinish,
        onBefore,
    })
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useTableColumnsCheck(columns)
    useEffect(() => {
        checkAll()
        getCarouselsData({
            name: name
        })
    }, [])

    return <Row>
        <Col span={24}>
            <Row>
                <Col span={24}>
                    <ProTableOT
                        actionRef={actionRef}
                        headerTitle={<></>}
                        columns={columns}
                        check={check}
                        setCheck={setCheck}
                        rowKey={'classify_structure_type_carousel_id'}
                        selections={{
                            // onChange: (index_, data_) => set_data(data_)
                        }}
                        toolBarRender={() => [
                        ]}
                        extra_columns={extra_columns}
                        set_extra_columns={set_extra_columns}
                        manage_columns={false}
                        request={async (params = {}, sort, filter) => {
                            setAxiosMode("get")
                            let newParams = {
                            };
                            let order = setOrders(sort)
                            newParams = {
                                ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                ...newParams,
                                name,
                                order,
                                size: params.pageSize,
                                cur_page: params.current,
                                custom_filter_value: params.keyword ?? "",
                                custom_filter_key: custom_filter_key
                            };
                            newParams = setParamsFilter({
                                ...newParams,
                            });
                            setPageSize(params?.pageSize ?? 20)

                            return getClassifyStructureTypeCarouselData(newParams)
                        }}
                        pageSize={pageSize}
                        rowSelection={{
                            type: 'checkbox',
                            selectedRowKeys: selectedRowKeys,
                            ...rowSelection,
                        }}
                        tableAlertOptionRender={() => {
                            return (
                                <Space size={16}>
                                    {/* <Typography.Link>匯出資料</Typography.Link> */}
                                </Space>
                            )
                        }}
                        tableAlertRender={({
                            selectedRowKeys,
                            selectedRows,
                            // onCleanSelected,
                        }) => {
                            return (
                                <Space size={24}>
                                    <span>
                                        已選擇 {selectedRowKeys.length} 項
                                        <a style={{ marginInlineStart: 8 }} onClick={onCleanSelected}>
                                            取消選擇
                                        </a>
                                    </span>
                                </Space>
                            );
                        }}
                        scroll={{
                            x: "max-content"
                        }}
                        propsUseData={() => {
                            return {
                                postData: postClassifyStructureTypeCarouselData,
                                patchData: patchClassifyStructureTypeCarouselData,
                                deleteData: deleteClassifyStructureTypeCarouselData
                            }
                        }}
                        modalOpen={modalOpen}
                        setModalOpen={setModalOpen}
                        PropsPatchForm={<ClassifyStructureTypeCarouselForm />}
                        propsPatch
                        propsPost
                        propsDelete
                        formMode={true}
                        propsWidth={1000}
                        initialValues={{
                            carousel_id: CarouselsData.find(_ => true)?.carousel_id
                        }}
                        propsPatchProcess={
                            (record) => {
                                let start_time = record?.start_time && dayjs(record?.start_time).format("YYYY-MM-DD")
                                let end_time = record?.end_time && dayjs(record?.end_time).format("YYYY-MM-DD")
                                return {
                                    ...record,
                                    start_time,
                                    end_time,
                                }
                            }
                        }
                    />
                </Col>
            </Row>
        </Col>
    </Row>
}


const useTableColumnsCheck = (columns) => {
    const [check, setCheck] = useState([])
    const checkAll = () => {
        setCheck((pre) => {
            return columns
                .filter((element) => !element.disabled)
                .map((val) => val.key);
        });
    }
    const setOrders = (sorter) => {
        if (sorter) {
            let newOrders = Object.keys(sorter).map((key, index) => {
                if (sorter[key] === "descend") {
                    return JSON.stringify({
                        column: key,
                        type: 'DESC'
                    })
                }
                else {
                    return JSON.stringify({
                        column: key,
                        type: 'ASC'
                    })
                }

            })
            return newOrders
        }
        else {
            return []
        }
    }
    return {
        check,
        custom_filter_key: check,
        setCheck,
        checkAll,
        setOrders
    }
}
export default ClassifyStructureTypeCarousel;
const PreviewCarousel = ({
    fileId = []
}) => {
    const [fileUrl, setFileUrl] = useState({})
    useEffect(() => {
        fileId.forEach(async item => {
            let tmp = await axios
                .get('/component/file', { responseType: 'blob', params: { "file_id": item } })
                .then((response) => {
                    var blob_ = new Blob([response.data], {
                        type: "image/jpg",// this is the only MIME for SVG

                    });
                    const dataurl = URL.createObjectURL(blob_);
                    return dataurl
                });
            setFileUrl(pre => (
                {
                    ...pre,
                    [item]: tmp
                }
            ))
        });
    }, [fileId])
    return <>
        <div
            style={{
                width: '200px'
            }}
        >
            <Carousel_news_ticker
                file_url={fileId.map(item => fileUrl?.[item])}
            />
        </div>
    </>
}